<div class="breadcrumbs">
    <div>/</div>
    <div>Governance</div>
    <div>/</div>
    <div class="hasLink" [routerLink]="['/data-catalogue']">Data Catalogues</div>
    <div>/</div>
    <div>Facilis Origin AIXM 5.1</div>
    <div>/</div>
    <div class="hasLink" [routerLink]="['/data-catalogue/business-rules']">Business Rules</div>
</div>
<mat-toolbar class="toolbar-custom">
  <span>
    <h3>Business Rules</h3>
  </span>
  <span class="toolbar-icon" [routerLink]="['/data-catalogue/business-rules/create']" >
    <mat-icon class="add-icon" color="warn" style="cursor: pointer; " >add_circle</mat-icon>
  </span>
</mat-toolbar>

<div class="filters-toolbar">
    <form [formGroup]="form">
        <div class="form-row first-row">

            <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
                <mat-label>Filter rule by title...</mat-label>
                <input
                        type="text"
                        matInput
                        formControlName="byRuleTitle"
                        placeholder=""
                />
            </mat-form-field>

            <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
                <mat-label>Filter by ruleset...</mat-label>
                <mat-select formControlName="byRuleset">
                    <mat-option *ngFor="let p of rulesets" [value]="p">{{
                        p
                        }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
                <mat-label>Filter by feature...</mat-label>
                <mat-select formControlName="byFeature">
                    <mat-option *ngFor="let p of features" [value]="p">{{
                        p
                        }}</mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </form>
</div>

<div class="metadata-container">
    <mat-expansion-panel
            class="custom-panel"
    >
        <mat-expansion-panel-header>
            <mat-panel-title><b>Ruleset metadata</b> </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="metadata-content">
            <div class="metadata-detailed-item">
                <div class="metadata-detail-key">Name:</div>
                <div class="metadata-detail-value">BHANSA AIXM Business Rules</div>
            </div>
            <div class="metadata-item">
                <div class="metadata-key">Last edited by:</div>
                <div class="metadata-value">john.doe</div>
            </div>
            <div class="metadata-item">
                <div class="metadata-key">Last edited on:</div>
                <div class="metadata-value">1 Feb 2025</div>
            </div>
        </div>
    </mat-expansion-panel>
</div>

<div class="table-wrapper">
    <table
      mat-table
      [dataSource]="rules"
      class="mat-elevation-z2 full-width-table"
    >
        <ng-container matColumnDef="ruleTitle">
            <th mat-header-cell *matHeaderCellDef>Rule title</th>
            <td class="hasLink" [routerLink]="['/data-catalogue/business-rules/' + element.id]" mat-cell *matCellDef="let element">{{ element.title }}</td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let element">{{ element.description }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>